import { motion } from "framer-motion";
import { Flag, Heart, BarChart3, Home, GraduationCap, Users } from "lucide-react";

const focusAreas = [
  { label: "Health & Wellness", icon: Heart, active: true },
  { label: "Economic Mobility", icon: BarChart3 },
  { label: "Housing", icon: Home },
  { label: "Education", icon: GraduationCap },
  { label: "Civic Power", icon: Users },
];

const MissionFocusCard = () => {
  return (
    <section className="bg-cream pt-12 md:pt-16">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-[var(--radius)] bg-card border border-border shadow-card p-6 md:p-8"
        >
          <div className="flex items-start gap-4 mb-6">
            <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <Flag className="h-5 w-5 text-primary" />
            </div>
            <div>
              <div className="text-primary text-xs font-semibold tracking-[0.2em] uppercase mb-1">
                The Mission
              </div>
              <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground">
                Five focus areas powering Alabama
              </h2>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 md:gap-3">
            {focusAreas.map((area) => {
              const Icon = area.icon;
              return (
                <button
                  key={area.label}
                  className={`inline-flex items-center gap-2 px-4 md:px-5 py-2.5 rounded-full border text-sm font-medium transition-colors ${
                    area.active
                      ? "bg-[hsl(345_70%_92%)] border-[hsl(345_50%_80%)] text-[hsl(345_50%_35%)]"
                      : "bg-muted border-border text-foreground hover:border-primary/40"
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  {area.label}
                </button>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionFocusCard;